module.exports = __webpack_public_path__ + "img/RawaZaydan.b96c8881.jpg";